module.exports = __webpack_public_path__ + "afa76e83208ceb5dceb04a9985a6bd6b.png";